import { CSSProperties } from "react";
import { PdfPreviewContent } from "../PdfPreviewContent";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export const StudentSituationPdf = () => {
  const studentSituation = useSelector((state: RootState) => state.studentSituation);
  const studentData = useSelector((state: RootState) => state.student);
  const userData = useSelector((state: RootState) => state.user);
  const currentDate = new Date().toLocaleDateString("pt-PT");

  const styles: { [key: string]: CSSProperties } = {
    container: {
      fontFamily: "Arial, sans-serif",
      padding: "20px",
      lineHeight: "1.5",
      fontSize: "12px",
      border: "1px solid #ddd",
      backgroundColor: "white",
    },
    header: {
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "20px",
      textTransform: "uppercase",
    },
    section: {
      marginBottom: "10px",
    },
    label: {
      fontWeight: "bold",
      display: "inline-block",
      width: "200px",
    },
    inputLine: {
      borderBottom: "1px solid black",
      width: "70%",
      display: "inline-block",
    },
    textarea: {
      width: "100%",
      border: "1px solid black",
      minHeight: "60px",
      padding: "5px",
      fontSize: "12px",
    },
    footer: {
      marginTop: "40px",
      textAlign: "center",
      fontSize: "10px",
    },
  };

  return (
    <PdfPreviewContent>
      <div style={styles.container}>
        <div style={styles.header}>Irregularidade do Estudante</div>

        <div style={styles.section}>
          <span style={styles.label}>Nome do Estudante:</span>
          <span style={styles.inputLine}>{userData?.name || "______________________"}</span>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Código do Estudante:</span>
          <span style={styles.inputLine}>{studentData?.student?.schoolCode || "______________________"}</span>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Curso:</span>
          <span style={styles.inputLine}>{studentData?.student?.course || "______________________"}</span>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Ano Acadêmico:</span>
          <span style={styles.inputLine}>{studentSituation?.academicYear || "______________________"}</span>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Descrição:</span>
          <textarea style={styles.textarea}>{studentSituation?.description || ""}</textarea>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Problema:</span>
          <textarea style={styles.textarea}>{studentSituation?.problem || ""}</textarea>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Solução:</span>
          <textarea style={styles.textarea}>{studentSituation?.soluction || ""}</textarea>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Motivo:</span>
          <textarea style={styles.textarea}>{studentSituation?.reason || ""}</textarea>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Resolvido:</span>
          <span style={styles.inputLine}>{studentSituation?.isResolved ? "Sim" : "Não"}</span>
        </div>

        <div style={styles.section}>
          <span style={styles.label}>Data de Registro:</span>
          <span style={styles.inputLine}>{currentDate}</span>
        </div>

        <div style={styles.footer}>
          <p>___________________________</p>
          <p>Assinatura do Responsável</p>
        </div>
      </div>
    </PdfPreviewContent>
  );
};
